module.exports = __webpack_public_path__ + "img/Credit-Card-Hand.26fb8c65.svg";